import intl from "react-intl-universal";

const selectPropsDefault = {
  valueKey: "Id",
  labelKey: "Descricao",
  value: [],
  options: [],
  searchable: true,
  clearable: true,
  multi: false,
  hidden: false,
};

export const materialGroupSelectFilters = () => [
  {
    ...selectPropsDefault,
    name: "MaterialGroupId",
    label: intl.get("commons.wallet"),
    placeholder: intl.get("commons.wallet"),
    valueKey: "Id",
    labelKey: "Description",
  },
];

export const materialGroupFilterDefault = {
  MaterialGroupId: null,
  _page: 0,
  _size: 100,
};

export const familySelectFilters = () => [
  {
    ...selectPropsDefault,
    name: "MaterialGroupId",
    label: intl.get("commons.wallet"),
    placeholder: intl.get("commons.wallet"),
    valueKey: "Id",
    labelKey: "Description",
  },
  {
    ...selectPropsDefault,
    name: "FamilyId",
    label: intl.get("commons.family"),
    placeholder: intl.get("commons.family"),
    valueKey: "Id",
    labelKey: "Name",
  },
];

export const familyFilterDefault = {
  MaterialGroupId: null,
  FamilyId: null,
  _page: 0,
  _size: 100,
};

export const validateFilter = (filter) => {
  return Object.keys(filter).some((key) =>
    filter[key] !== null &&
    filter[key] !== "" &&
    key !== "_page" &&
    key !== "_size"
  );
};
